// Angular
import { Component, Input, OnInit } from '@angular/core';
import { ApplicationTrackingService } from '../../../../pages/application-tracking/services/application-tracking.service';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';

export interface Timeline2Data {
	time: string;
	text: string;
	icon?: string;
	attachment?: string;
}

@Component({
	selector: 'kt-timeline2',
	templateUrl: './timeline2.component.html',
	styleUrls: ['./timeline2.component.scss']
})
export class Timeline2Component implements OnInit {
	// Public properties
	@Input() data: Timeline2Data[];
	public applicationid:any;
	@Input('getLatestAppData') getLatestAppData: any;
	@Input('appId') appId: any;
	@Input('applicationList') applicationList: any;
	@Input('acronym') acronym: any;
	public appTypeAcronym:any;
	public appsList: any = [];
	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	constructor(private trackingService: ApplicationTrackingService,) {
	}
	ngOnInit() {
		this.applicationid = this.appId
		this.appTypeAcronym = this.acronym;
	}

	public getDate(date): any {
		if (date) {
			date = new Date(date)
			let month: any;
			let dated: any;
			if (date.getDate().toString().length < 2) {
				dated = '0' + date.getDate().toString()
			} else {
				dated = date.getDate().toString()
			}
			if ((date.getMonth() + 1).toString().length < 2) {
				month = '0' + (date.getMonth() + 1).toString()
			} else {
				month = (date.getMonth() + 1).toString()
			}
			let convertedDate = date.getFullYear() + "-" + month + "-" + dated;
			return convertedDate
		} else {
			return 'IN-PROCESS'
		}
	}

	public getLatestApplicationId(id) {
		console.log(this.acronym)
		console.log(id)
		this.applicationList.forEach(element => {
			if(element.appId == id){
				this.acronym = element.acronym
			}
		});
		if (this.acronym == 'DAS') {
			this.trackingService.getDasTrackingData(id).subscribe(
				(res) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (res.data) {
							this.getLatestAppData = res.data.dasDetailedAuditDto;
						}
					}
					else {
						this.getLatestAppData = [];
					}
				},
				(err) => {
					this.getLatestAppData = [];

				}
			);
		} else if (this.acronym == 'DES') {
			this.trackingService.getDesTrackingData(id,'des').subscribe(
				(res) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (res.data) {
							this.getLatestAppData = res.data.dasDetailedAuditDto;
						}
					}
					else {
						this.getLatestAppData = [];
					}
				},
				(err) => {
					this.getLatestAppData = [];

				}
			);
		}
		else if (this.acronym == 'DESF') {
			this.trackingService.getDesTrackingData(id,'desf').subscribe(
				(res) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (res.data) {
							this.getLatestAppData = res.data.dasDetailedAuditDto;
						}
					}
					else {
						this.getLatestAppData = [];
					}
				},
				(err) => {
					this.getLatestAppData = [];

				}
			);
		}
	}
}
